import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { deleteTaskFileAction, getTaskAction } from '../../../../../redux/tasks/actions';
import { getOpenedTaskFiles } from '../../../../../redux/tasks/taskEntities/selectors';
import TaskFileHolder from '../../../organisms/TaskFileHolder';

const TaskDetailsFilesSection = ({ taskId, taskFiles }) => {
  const dispatch = useDispatch();
  const params = useParams();

  const delAttachment = useCallback((fileId) => {
    dispatch(
      deleteTaskFileAction(taskId || params.taskid, fileId, () =>
        dispatch(getTaskAction(taskId || params.taskid)),
      ),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.taskid, taskId]);

  return (
    <div className="flex flex-wrap">
      {taskFiles?.length > 0 ? (
        <div className="flex flex-col">
          <TaskFileHolder
            files={taskFiles || []}
            taskId={taskId}
            delAttachment={delAttachment}
          />
        </div>
      ) : (
        <div className="font-14 font-bold p-2">
          <FormattedMessage id="NO_FILES" defaultMessage="No Files" />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  taskId: getOpenedTaskId(state),
  taskFiles: getOpenedTaskFiles(state),
});

export default connect(mapStateToProps)(TaskDetailsFilesSection);
